import { render, staticRenderFns } from "./messageSurvey.vue?vue&type=template&id=4d6fc3ae&"
import script from "./messageSurvey.vue?vue&type=script&lang=js&"
export * from "./messageSurvey.vue?vue&type=script&lang=js&"
import style0 from "./messageSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports